module.exports = __webpack_public_path__ + "static/img/icon05.a1c239a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon05.png
// module id = 4l8J
// module chunks = 1